import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { BathroomService } from 'src/app/services/configurators-2d/applications/bathroom.service';
import { BathroomRangeDto } from 'src/app/models/configurators-2d/common-bathroom-dtos';

@Component({
  selector: 'ng-casto-bathroom-range-selector',
  templateUrl: './bathroom-range-selector.component.html',
  styleUrls: ['./bathroom-range-selector.component.scss'],
})
export class BathroomRangeSelectorComponent implements OnInit {
  @Input() embedded: boolean = false;
  @Input() layoutMode: 'mobile' | 'desktop' = 'mobile';
  @Input() autoSelectFirstRange: boolean = true;
  @Output() rangeSelected = new EventEmitter<BathroomRangeDto>();
  @Output() backRequested = new EventEmitter<void>();

  faArrowLeft = faArrowLeft;
  availableRanges: BathroomRangeDto[] = [];
  isLoading = false;

  constructor(
    private router: Router,
    private location: Location,
    private bathroomService: BathroomService
  ) { }

  ngOnInit(): void {
    this.loadAvailableRanges();
  }

  private async loadAvailableRanges(): Promise<void> {
    this.isLoading = true;
    try {
      this.availableRanges = await this.bathroomService.getAllRange();

      // Redirection automatique si une seule gamme
      if (this.availableRanges.length > 0 && this.autoSelectFirstRange && !this.embedded) {
        this.selectRange(this.availableRanges[0]);
      }
    } catch (error) {
      console.error('Erreur chargement gammes', error);
    } finally {
      this.isLoading = false;
    }
  }

  selectRange(range: BathroomRangeDto): void {
    if (this.embedded) {
      this.rangeSelected.emit(range);
      return;
    }

    this.router.navigate(['/salle-de-bain-mobile/compositions', range.id]);
  }

  goBack(): void {
    if (this.embedded) {
      this.backRequested.emit();
      return;
    }

    this.location.back();
  }
}
